/* istanbul ignore file */
import React from 'react';
import InCondition from '../../../condition/InCondition';
import InOrCondition from '../../../condition/OrCondition';
import { DropDownFilterLayoutType } from '../../../DropDownFilter';
import { FilterCondition } from 'framework/types';

const DropDownFilterLayout: DropDownFilterLayoutType = ({
  source,
  onChangeCallback,
  getDropdownValue,
  children,
  isSingle = false,
  label = '',
  conditionType = FilterCondition.IN,
}) => {
  const ConditionRoot = conditionType === FilterCondition.OR ? InOrCondition : InCondition;

  return (
    <ConditionRoot source={source} onChangeCallback={onChangeCallback} value={getDropdownValue(true)}>
      {React.cloneElement(children, { multiple: !isSingle, placeholder: 'Select...', label })}
    </ConditionRoot>
  );
};

export default DropDownFilterLayout;
